import { IRootState } from '../../../store'
import { ISignatureOptionsState } from '../store/options.types'

export const getSignatureOptionsSelector = (state: IRootState): ISignatureOptionsState => state.options.signatureOptions
